import React from "react";
import '../pages/History.css';
import Footer from '../Footer';

function History() {

    return (
        <>
            <div id="parallax-world-of-ugg">

                <section>
                    <div class="title">
                        <h3 style={{ fontStyle: "italic" }}>Historia</h3>
                        <h1 style={{ fontStyle: "italic" }}>Prinx Tires</h1>
                    </div>
                </section>

                <section>
                    <div class="parallax-one">
                        <h2>China</h2>
                    </div>
                </section>

                <section>
                    <div class="block">
                        <p><span class="first-character sc">L</span>a historia de la empresa se remonta a 1976. En 1981, Prinx Chengshan construyó su primera línea de producción de neumáticos radiales y siguió aumentando su sólida reputación en la industria de los neumáticos.
                            En 2005, la Compañía estableció una empresa conjunta con un importante fabricante de neumáticos de EE. UU., lo que permitió a Prinx Chengshan expandir aún más el desarrollo de sus productos de neumáticos para pasajeros, camiones y autobuses, así como neumáticos agrícolas e industriales. En 2014, la empresa tomó una nueva dirección, puso fin a la empresa conjunta y estableció Prinx Chengshan (Shandong) Tire Company, marcando oficialmente el comienzo de una nueva era de productos y tecnología.
                            El 25 de marzo de 2020, el primer neumático TBR de la marca Prinx de la compañía salió con éxito de su nueva línea de producción, seguido rápidamente por un neumático para el segmento PLT. La instalación utiliza maquinaria procedente de los principales proveedores de equipos del mundo y Prinx Chengshan está integrando la fabricación inteligente en los procesos de producción y almacenamiento.
                        </p>
                        <p class="line-break margin-top-10"></p>
                        <p class="margin-top-10">
                            En la actualidad, Prinx Chengshan Holding Limited vende sus neumáticos en más de 130 países y regiones de seis continentes.
                            Como empresa global de neumáticos, Prinx Chengshan innova continuamente en nuevas tecnologías, confiando en la fuerza de la investigación y el desarrollo para promover el avance y la optimización de sus productos.
                            TBC Corporation se enorgullece de ser el distribuidor exclusivo de productos de calidad de Prinx Tires en Norteamérica y actualmente ofrece neumáticos PLT y TBR.

                        </p>
                    </div>
                </section>

                <section>
                    <div class="parallax-two">
                        <h2>Venezuela</h2>
                    </div>
                </section>

                <section>
                    <div class="block">
                        <p><span class="first-character ny">P</span>rinx Tires abre sus puertas al mundo a comienzos de esta década, contando con todas las certificaciones de comercialización internacional, establece una de sus fábricas en Tailandia solo para producción internacional.
                            Logrando posición en los principales mercados del mundo comenzando con Europa y EE.UU. con una producción de neumáticos de calidad Premium exporta a todo el mundo, logrando llegar a Venezuela con tan solo 3 años de diferencia a sus mercados más importantes antes mencionados.
                        </p>
                        <p class="line-break margin-top-10"></p>
                        <p class="margin-top-10">Gracias a Cauchos la Mundial, establece la alianza definitiva para el mercado nacional y estar en toda Venezuela por su experiencia y estructuras en el proceso de distribucion de neumáticos.</p>
                    </div>
                </section>

                <section>
                    <div class="parallax-three">
                        <h2>Cauchos La Mundial</h2>
                    </div>
                </section>

                <section>
                    <div class="block">
                        <p><span class="first-character atw">C</span>auchos La Mundial gracias a sus relacion de casi 20 años con el gigante fabricante de neumáticos PRINX CHENGSHAN comienzan operaciones y colocan sus productos en toda la red de distribucion de sus aliados en toda Venezuela, respaldando su calidad y precios en toda la región, logrando el posicionamiento de la marca Premium PRINX, comenzando con la linea de todo terreno con llantas de la mejor calidad.</p>
                        {/* <p class="line-break margin-top-10"></p> */}
                        {/* <p class="margin-top-10"></p> */}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
}

export default History;